import React from 'react'
import './FlowStageError.scss'

import Div100Vh from 'react-div-100vh'

const FlowStageError = ({onCancel, onRestart}) => (
  <Div100Vh className="flow-stage-error--container">
    <h2>Oops, something wrong!</h2>
    <button onClick={onRestart}>Try Again</button>
    <button onClick={onCancel}>No Thanks</button>
  </Div100Vh>
)

export default FlowStageError